import { connect } from 'react-redux';

import CptDashboard from '../components/CptDashboard';
import {
  onCptQueryInputChange,
  loadCptInfo,
  initLoadCptInfoActionStatus,
  selectCptInfo,
  openAddOrEditCptModal,
  addOrEditCptChangeInput,
  addOrEditCpt,
  initAddOrEditCptActionStatus,
  resetAddOrEditCptModal,
  openDelCptModal,
  delCpt,
  initDelCptActionStatus,
  resetDelCptModal,
  submitCpt,
  initSubmitCptActionStatus,
} from '../CptActions';

import { doOperationRecordAction } from '../../common/historyUpload/operationRcd/OperationRecordActions';

const mapStateToProps = state => {
  return {
    cptOperationRecordUrl: state.cpt.cptOperationRecordUrl,
    cptQueryFields: state.cpt.cptQueryFields,
    loadCptInfoActionStatus: state.cpt.loadCptInfoActionStatus,
    loadCptInfoResp: state.cpt.loadCptInfoResp,
    selectedCptInfoArray: state.cpt.selectedCptInfoArray,
    addOrEditCptModal: state.cpt.addOrEditCptModal,
    addOrEditCptActionStatus: state.cpt.addOrEditCptActionStatus,
    delCptModal: state.cpt.delCptModal,
    delCptActionStatus: state.cpt.delCptActionStatus,
    submitCptActionStatus: state.cpt.submitCptActionStatus,
    submitCptRespErrMsg: state.cpt.submitCptRespErrMsg,
    operationRecord: state.operationRecord,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onCptQueryInputChange: params => dispatch(onCptQueryInputChange(params)),
    loadCptInfo: params => dispatch(loadCptInfo(params)),
    initLoadCptInfoActionStatus: () => dispatch(initLoadCptInfoActionStatus()),
    selectCptInfo: array => dispatch(selectCptInfo(array)),
    openAddOrEditCptModal: (mode, data) => dispatch(openAddOrEditCptModal(mode, data)),
    addOrEditCptChangeInput: params => dispatch(addOrEditCptChangeInput(params)),
    addOrEditCpt: params => dispatch(addOrEditCpt(params)),
    initAddOrEditCptActionStatus: () => dispatch(initAddOrEditCptActionStatus()),
    resetAddOrEditCptModal: () => dispatch(resetAddOrEditCptModal()),
    openDelCptModal: data => dispatch(openDelCptModal(data)),
    delCpt: params => dispatch(delCpt(params)),
    initDelCptActionStatus: () => dispatch(initDelCptActionStatus()),
    resetDelCptModal: () => dispatch(resetDelCptModal()),
    submitCpt: params => dispatch(submitCpt(params)),
    initSubmitCptActionStatus: () => dispatch(initSubmitCptActionStatus()),
    doOperationRecordAction: params => dispatch(doOperationRecordAction(params)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CptDashboard);
